<template>
  <div>
    <CustomCollaspe
      class="filter-collapse collection"
      :collapse-id="'collection-collapse'"
      :collapse-header="'Collections'"
    >
      <SearchInput class="custom-search-input" :placeholder="'Search'" />
      <FilterOptionBtn @onClick="$emit('viewCollection', 1)">
        Top Collection 1
      </FilterOptionBtn>
      <FilterOptionBtn @onClick="$emit('viewCollection', 2)">
        Top Collection 2
      </FilterOptionBtn>
      <FilterOptionBtn @onClick="$emit('viewCollection', 3)">
        Top Collection 2
      </FilterOptionBtn>
    </CustomCollaspe>
  </div>
</template>

<script>
import CustomCollaspe from '@/components/BaseComponents/CustomCollapse.vue';
import SearchInput from '@/components/BaseComponents/SearchInput.vue';
import FilterOptionBtn from '@/components/BaseComponents/FilterOptionBtn.vue';

export default {
  components: {
    CustomCollaspe,
    SearchInput,
    FilterOptionBtn
  }
};
</script>
